import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const ITEMS = [
  "Saint-Jean-Cap-Ferrat",
  "Cannes — La Croisette",
  "Cap d'Antibes",
  "Mougins",
  "Nice — Baie des Anges",
  "Juan-les-Pins",
  "Saint-Raphaël",
  "Monaco",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-slate-200/70 bg-[#F3EEE6] py-5">
      <Marquee speed={25} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className="whitespace-nowrap font-serif text-xl italic text-azur/80 sm:text-2xl">{item}</span>
            <Sparkle size={13} className="text-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
